<template>

    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :form-fields="formFields" :permission="permission" :searchs="searchs" ref="table"></common-table>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "QuotaFlow",
        components: {CommonTable},
        data(){
            return {
                searchs:[
                    {
                        name: 'username',
                        placeholder: '用户名',
                        type: 'input'
                    },
                    {
                        name: 'type',
                        placeholder: '类型',
                        type: 'select',
                        selectUrl:'',
                        selectValue: [{
                            key: 0,
                            value: '接单扣除'
                        },{
                            key: 1,
                            value: '系统退回'
                        },{
                            key: 2,
                            value: '加款'
                        },{
                            key: 3,
                            value: '减款'
                        }]
                    },
                    {
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }
                ],
                permission:{
                    add: 'quotaFlow:add',
                    update: 'quotaFlow:update',
                    delete: 'quotaFlow:delete',
                    deleteBatch: 'quotaFlow:deleteBatch'
                },
                url: {
                    get: '/quotaFlow/listByCondition',
                    //add: '/operationLog/add',
                    //update: '/operationLog/update',
                    //delete: '/operationLog/delete/',
                    //delete_batch: '/operationLog/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '75',
                }, {
                    field: 'type',
                    label: '类型',
                    selectUrl:'',
                    selectData: [{
                        id: 0,
                        name: '接单扣除'
                    },{
                        id: 1,
                        name: '系统退回'
                    },{
                        id: 2,
                        name: '加款'
                    },{
                        id: 3,
                        name: '减款'
                    }],
                    show: {
                        type: 'select'
                    },
                    width: '',
                }, {
                    field: 'userNick',
                    label: '用户昵称',
                    show: true,
                    width: '',
                }, {
                    field: 'limit',
                    label: '额度(元)',
                    show: {
                        type: 'money'
                    },
                    width: '',
                }, {
                    field: 'startLimit',
                    label: '开始额度(元)',
                    show: {
                        type: 'money'
                    },
                    width: '',
                }, {
                    field: 'endLimit',
                    label: '结束额度(元)',
                    show: {
                        type: 'money'
                    },
                    width: '',
                }, {
                    field: 'siteId',
                    label: '网站',
                    selectUrl: '/siteInfo/getAll',
                    selectData: [],
                    show: {
                        type: 'select'
                    },
                    width: '',
                }, {
                    field: 'createTime',
                    label: '创建时间',
                    show: true,
                    width: '',
                }],
                operate: [],
                formFields: {
                    addTitle: '添加',
                    updateTitle: '修改',
                    model: []
                }
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>

</style>
